export default function getEventDateTime({ eventDateMS, offset }) {
  const msInADay = 86400000
  const msInAnHour = 3600000
  const msInAMinute = 60000
  const nowMS = Date.now() + offset

  let msToAccountFor = eventDateMS - nowMS

  const days = msToAccountFor > 0 ? Math.floor(msToAccountFor / msInADay) : 0
  if (msToAccountFor > days * msInADay) msToAccountFor -= days * msInADay

  const hours = msToAccountFor > 0 ? Math.floor(msToAccountFor / msInAnHour) : 0
  if (msToAccountFor > hours * msInAnHour) msToAccountFor -= hours * msInAnHour

  const minutes = msToAccountFor > 0 ? Math.floor(msToAccountFor / msInAMinute) : 0
  if (msToAccountFor > minutes * msInAMinute) msToAccountFor -= minutes * msInAMinute

  const seconds = msToAccountFor > 0 ? Math.floor(msToAccountFor / 1000) : 0
  if (msToAccountFor > Math.floor(msToAccountFor / 1000)) msToAccountFor -= seconds * 1000

  return { eventDateMS, nowMS, days, hours, minutes, seconds }
}
